module.exports = __webpack_public_path__ + "static/media/tcs-logo-white.7f68d133.svg";